class StockLocationDetailController extends AbstractStockLocationController
	@register()
	@inject 'stockLocation',
		'StockLocationRepository'

	initialize: ->
		super()

		@mainCrud.showFormActionButtons = true

	save: ->
		@mainCrud.saving = true

		@StockLocationRepository
			.save @stockLocation, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors response, 'general.stock.location'

	delete: ->
		@deleteEntity @StockLocationRepository, @stockLocation
